import Vue from "vue";
import Vuex from "vuex";
import state from './state.js'
import actions from './actions.js'
import mutations from './mutations'
import getters from './getters'
// import employee from './modules/employee'
// import observation from './modules/observation'
// import student from './modules/student'
// import teacher from './modules/teacher'
import VuexPersist from 'vuex-persist'

const vuexLocalStorage = new VuexPersist({
  key: 'hitutorclassroom',
})

Vue.use(Vuex);

export default new Vuex.Store({
  // modules: {
  //   agora,
  //   employee,
  //   observation,
  //   student,
  //   teacher,
  // },
  plugins: [vuexLocalStorage.plugin],
  state,
  actions,
  mutations,
  getters,

});
